import { render, staticRenderFns } from "./MaterialCategorylist.vue?vue&type=template&id=fadd0a56&scoped=true&"
import script from "./MaterialCategorylist.vue?vue&type=script&lang=js&"
export * from "./MaterialCategorylist.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCategorylist.vue?vue&type=style&index=0&id=fadd0a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadd0a56",
  null
  
)

export default component.exports